import React, { useState } from "react";

import { Redirect, Link } from "react-router-dom";
import arrowBackIcon from "../../img/arrow_back_ios-black-36dp.svg";

const Register = (props) => {
  const [email, setEmail] = useState("");
  const [passsword, setPasssword] = useState("");
  const [rePasssword, setRePasssword] = useState("");
  const [error, setError] = useState("");
  const [emailError, setEmailError] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmError, setConfirmError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState("");
  const [passwordErrorMessage, setPasswordErrorMessage] = useState("");
  const [confirmErrorMessage, setConfirmErrorMessage] = useState("");
  const [registerClick, setRegisterClick] = useState(false);

  const [redirect] = useState(false);

  const validate = () => {
    let hasError = false;
    setError("");
    setEmailError(false);
    setPasswordError(false);
    setConfirmError(false);
    setEmailErrorMessage("");
    setPasswordErrorMessage("");
    setConfirmErrorMessage("");
    const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    if (email === "" || !emailValid) {
      setEmailError(true);
      setEmailErrorMessage(email === "" ? "Email is required." : "Invalid email.");
      hasError = true;
    }
    if (passsword === "") {
      setPasswordError(true);
      setPasswordErrorMessage("Password is required.");
      hasError = true;
    }
    if (rePasssword === "") {
      setConfirmError(true);
      setConfirmErrorMessage("Confirm password is required.");
      hasError = true;
    }
    if (hasError) {
      return false;
    }
    if (passsword !== rePasssword) {
      setConfirmError(true);
      setConfirmErrorMessage("Passwords do not match.");
      return false;
    }
    return true;
  };

  const register = async () => {
    if (!validate()) {
      return;
    }
    setRegisterClick(true);
    let registerURL = props.baseUrl + props.register_url;

    const body = {
      email: email,
      password: passsword,
    };
    try {
      const response = await fetch(registerURL, {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        credentials: "include", // include cookies for auth
        headers: {
          "Content-Type": "application/json",
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(body), // body data type must match "Content-Type" header
      });

      const json = await response.json();

      console.log("response:", json);
      if (response.status === 201) {
        console.log(json);
        // Auth cookies (at/rt) are set automatically by the server response
        localStorage.setItem("email", json.user.email);
        //setRegisterClick(false);
        window.location = "/";
      }
      if (response.status === 400) {
        setError("*" + json.error);
        setRegisterClick(false);
      }
      return;
    } catch (error) {
      setError(error);
      setRegisterClick(false);
    }
  };
  const register_buttun = (
    <span className="flex items-center justify-center gap-2">
      {registerClick && (
        <svg
          className="h-4 w-4 animate-spin text-white"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          ></path>
        </svg>
      )}
      <span>Create Account</span>
    </span>
  );

  return redirect ? (
    <Redirect to="/settings"></Redirect>
  ) : (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto flex min-h-[70vh] w-full max-w-md flex-col items-center">
        <div className="mb-4 flex w-full justify-start">
          <Link
            to="/home"
            className="inline-flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-slate-900"
            aria-label="Back to home"
          >
            <img src={arrowBackIcon} alt="" className="h-5 w-5" />
            Back
          </Link>
        </div>
        <div className="flex w-full flex-1 items-center">
        <div className="w-full rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
          <div className="mb-6 text-center text-2xl font-semibold text-slate-900">
            Register
          </div>

          <div className="space-y-4">
            <div>
              <input
                required={true}
                type="email"
                placeholder="Email"
                className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-slate-500 ${
                  emailError ? "border-red-500" : "border-slate-300"
                }`}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
                    e.target.value
                  );
                  setEmailError(e.target.value !== "" && !emailValid);
                  setEmailErrorMessage(
                    e.target.value !== "" && !emailValid ? "Invalid email." : ""
                  );
                }}
              />
              {emailErrorMessage && (
                <div className="mt-1 text-sm text-red-600">
                  {emailErrorMessage}
                </div>
              )}
            </div>
            <div>
              <input
                required={true}
                type="password"
                placeholder="Password"
                className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-slate-500 ${
                  passwordError ? "border-red-500" : "border-slate-300"
                }`}
                value={passsword}
                onChange={(e) => {
                  setPasssword(e.target.value);
                  setPasswordError(false);
                  setPasswordErrorMessage("");
                }}
              />
              {passwordErrorMessage && (
                <div className="mt-1 text-sm text-red-600">
                  {passwordErrorMessage}
                </div>
              )}
            </div>
            <div>
              <input
                required={true}
                type="password"
                placeholder="Confirm Password"
                className={`w-full rounded-md border px-3 py-2 text-sm outline-none focus:border-slate-500 ${
                  confirmError ? "border-red-500" : "border-slate-300"
                }`}
                value={rePasssword}
                onChange={(e) => {
                  setRePasssword(e.target.value);
                  setConfirmError(false);
                  setConfirmErrorMessage("");
                }}
              />
              {confirmErrorMessage && (
                <div className="mt-1 text-sm text-red-600">
                  {confirmErrorMessage}
                </div>
              )}
            </div>
            {error && <div className="text-sm text-red-600">{error}</div>}

            <button
              type="button"
              disabled={registerClick}
              className="w-full rounded-md bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-70"
              onClick={() => {
                register();
              }}
            >
              {register_buttun}
            </button>
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Register;
